export const formatDate = (value?: string | null) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
};

export const formatPrice = (amount?: number | null, currency?: string | null) => {
  if (amount === undefined || amount === null) return '-';
  const normalized = Number(amount);
  if (Number.isNaN(normalized)) return '-';
  return `${normalized.toLocaleString()}${currency ? ` ${currency}` : ''}`;
};

export const formatNumber = (value?: number | null) => {
  if (value === undefined || value === null) return '-';
  return value.toLocaleString();
};
